import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Button, Tabs, Tab } from 'react-bootstrap'

import { userIsPortalAdmin, userCanSeeAllRoutes } from '../../functions/userPermissions'

import { getAdverseEvents, setSelectedAdverseEventForPharmaVigilance } from './reducers/adverseEventsReducer'

import WithAuth from '../../HOCs/WithAuth'
import LoadingScreen from '../../components/LoadingScreen'
import AdverseEventCard from './components/AdverseEventCard'


class AdverseEventsContainer extends Component {

  componentDidMount() {
    this.props.getAdverseEvents(this.props.alert)
  }

  handleClick = (adverseEvent) => {
    this.props.setSelectedAdverseEventForPharmaVigilance(adverseEvent)
    this.props.routerProps.history.push(`adverse-drug-reactions/${adverseEvent.id}`)
  }

  render() {
    const { fetchingAdverseEvents, adverseEvents } = this.props

    const activeAdverseEvents = adverseEvents.filter(adverseEvent => !adverseEvent.addressed && !adverseEvent.deleted)

    const addressedAdverseEvents = adverseEvents.filter(adverseEvent => adverseEvent.addressed && !adverseEvent.deleted)

    const deletedAdverseEvents = adverseEvents.filter(adverseEvent => adverseEvent.deleted)

    if (fetchingAdverseEvents) {
      return <LoadingScreen text='Loading' />
    } else {
      return (
        <div className="ChartsContainer">
          <Tabs defaultActiveKey='active'>
            <Tab eventKey='active' title='Pending Acknowledgement'>
              <br/>
              <Row>
                {activeAdverseEvents && activeAdverseEvents.length ?
                  activeAdverseEvents.map(adverseEvent => {
                    return (
                      <Col
                        xs={12} sm={12} md={6} lg={4}
                        key={adverseEvent.id}
                      >
                        <AdverseEventCard
                          handleClick={() => this.handleClick(adverseEvent)}
                          adverseEvent={adverseEvent}
                        />
                      </Col>
                    )
                  })
                  :
                  <div style={{display: 'block'}}>
                    <h4>
                      There are no adverse drug reactions that are pending acknowledgement
                    </h4>
                  </div>
                }
              </Row>
            </Tab>

            <Tab eventKey='addressed' title='Acknowledged as Receieved'>
              <br/>
              {addressedAdverseEvents && addressedAdverseEvents.length ?
                <Row>
                  {addressedAdverseEvents.map(adverseEvent => {
                    return (
                      <Col
                        xs={12} sm={12} md={6} lg={4}
                        key={adverseEvent.id}
                      >
                        <AdverseEventCard
                          handleClick={() => this.handleClick(adverseEvent)}
                          adverseEvent={adverseEvent}
                        />
                      </Col>
                    )
                  })}
                  </Row>
                  :
                  <div>
                  <br/>
                  <br/>
                    <center>
                      <h4>
                        There are no adverse drug reactions that have been acknowledged as received
                      </h4>
                    </center>
                  </div>
                }
            </Tab>
            <Tab eventKey='deleted' title='Deleted'>
              <br/>
              {deletedAdverseEvents && deletedAdverseEvents.length ?
                <Row>
                  {deletedAdverseEvents.map(adverseEvent => {
                    return (
                      <Col
                        xs={12} sm={12} md={6} lg={4}
                        key={adverseEvent.id}
                      >
                        <AdverseEventCard
                          handleClick={() => this.handleClick(adverseEvent)}
                          adverseEvent={adverseEvent}
                        />
                      </Col>
                    )
                  })}
                  </Row>
                  :
                  <div>
                  <br/>
                  <br/>
                    <center>
                      <h4>
                        There are no adverse drug reactions that have been deleted
                      </h4>
                    </center>
                  </div>
                }
            </Tab>
          </Tabs>

          {userIsPortalAdmin(this.props.currentUser) || userCanSeeAllRoutes(this.props.currentUser) ?
            <Button onClick={() => this.props.routerProps.history.push('/home')}>
              Back
            </Button>
            :
            null
          }
        </div>
      )
    }
  }
}


const mapStateToProps = (state) => {
  return {
    currentUser: state.loginReducer.currentUser,
    fetchingAdverseEvents: state.adverseEventsReducer.fetchingAdverseEvents,
    adverseEvents: state.adverseEventsReducer.adverseEvents,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAdverseEvents: (alert) => dispatch(getAdverseEvents(alert)),

    setSelectedAdverseEventForPharmaVigilance: (adverseEvent) => {
      return dispatch(setSelectedAdverseEventForPharmaVigilance(adverseEvent))
    },
  }
}

export default WithAuth(connect(mapStateToProps, mapDispatchToProps)(AdverseEventsContainer))
